import storage from 'modules/storage';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import { LocalStorageKeys } from './types';

class NavigationManager {
  addStorageCategory(product: IAdaptedListProduct, categoryName: string) {
    return storage.local.setItem(LocalStorageKeys.productsCategories, {
      [product.referenceKey]: categoryName,
    });
  }

  getStorageCategories() {
    return storage.local.getItem(LocalStorageKeys.productsCategories);
  }

  removeStorageCategories() {
    return storage.local.removeItem(LocalStorageKeys.productsCategories);
  }
}

const navigationManager = new NavigationManager();

export default navigationManager;
